import { render } from "./LbrxListOrders.vue?vue&type=template&id=2d90137b"
import script from "./LbrxListOrders.vue?vue&type=script&lang=js"
export * from "./LbrxListOrders.vue?vue&type=script&lang=js"

import "./LbrxListOrders.vue?vue&type=style&index=0&id=2d90137b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__